export const selectNewPersonalAccessToken = state =>
  state.personalAccessTokens.newPersonalAccessToken;

export const selectTokens = state => state.personalAccessTokens.tokens;



// WEBPACK FOOTER //
// ./webpack/assets/javascripts/react_app/components/users/PersonalAccessTokens/PersonalAccessTokensSelectors.js